import { useState } from 'react';
import CompanyAdmin from './CompanyAdmin';
import Branches from './Branches';
import Races from './masters/Races';
import Religions from './masters/Religions';
import Nationalities from './masters/Nationalities';
import EducationLevels from './masters/EducationLevels';
import Funds from './masters/Funds';
import Banks from './masters/Banks';
import SalaryComponents from './SalaryComponents';

const PRIMARY_TABS = ['Company', 'Branch'] as const;
// ADM-29: "Additional Master Setup" — transferred from Payroll per HR's
// decision. Race/Religion/Nationality/Education/Fund/Bank/Component only;
// FWL and Daily stay under Payroll. "Career" deferred — no existing master
// or defined concept to relocate yet.
const ADDITIONAL_TABS = ['Race', 'Religion', 'Nationality', 'Education', 'Fund', 'Bank', 'Component'] as const;
type Tab = (typeof PRIMARY_TABS)[number] | (typeof ADDITIONAL_TABS)[number];

const TAB_CONTENT: Record<Tab, React.ComponentType> = {
  Company: CompanyAdmin,
  Branch: Branches,
  Race: Races,
  Religion: Religions,
  Nationality: Nationalities,
  Education: EducationLevels,
  Fund: Funds,
  Bank: Banks,
  Component: SalaryComponents,
};

export default function Master() {
  const [tab, setTab] = useState<Tab>('Company');

  const tabButton = (t: Tab) => (
    <button
      key={t}
      onClick={() => setTab(t)}
      className={`pb-2 text-sm font-medium ${tab === t ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-500'}`}
    >
      {t}
    </button>
  );

  const Content = TAB_CONTENT[tab];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Master</h1>

      <div className="flex gap-4 border-b mb-2">{PRIMARY_TABS.map(tabButton)}</div>

      <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mt-4 mb-1">Additional Master Setup</p>
      <div className="flex flex-wrap gap-4 border-b mb-6">{ADDITIONAL_TABS.map(tabButton)}</div>

      <div className="bg-white rounded-lg shadow p-6">
        <Content />
      </div>
    </div>
  );
}
